<template lang="pug">
  .component-json-conf
    textarea(v-model="json", @input="updateValue", rows="20", style="font-family:Monospace")
</template>

<script>
export default {
  name: 'JsonConf',
  mounted() {
    this.json = JSON.stringify(this.value, null, 2);
  },
  data() {
    return {
      json: ""
    }
  },
  methods: {
    updateValue() {
      this.$emit('input', this.json)
    }
  },
  props: ['value', 'item']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// JsonConf.vue?1f5cc25c